import { render, staticRenderFns } from "./inputHora.vue?vue&type=template&id=2be03fd1&"
import script from "./inputHora.vue?vue&type=script&lang=js&"
export * from "./inputHora.vue?vue&type=script&lang=js&"
import style0 from "./inputHora.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports